import RegistrationForm from "../../../components/Organisms/vendor-registration/forms/registerForm";

export default function VendorRegistrationTemplate({ options }) {
  return <RegistrationForm options={options} />;
}
